import {
  type CategoryStat,
  type Transaction,
  TransactionsDetailModal,
} from '@/modules/projects'
import { humanizeText } from '@/utils'
import { MetadataPanel } from './MetadataPanel'

interface CategoryDetailModalProps {
  stat: CategoryStat | null
  outlierTransactions: Transaction[]
  outlierCount: number
  outlierAmount: number
  onOpenChange: (open: boolean) => void
}

export function CategoryDetailModal({
  stat,
  outlierTransactions,
  outlierCount,
  outlierAmount,
  onOpenChange,
}: CategoryDetailModalProps) {
  const description =
    outlierTransactions.length === 0
      ? 'No transactions stood out in this category.'
      : `${outlierTransactions.length} transaction${outlierTransactions.length === 1 ? '' : 's'} where the amount moved, in or out, stands out from the usual pattern.`

  return (
    <TransactionsDetailModal
      open={!!stat}
      onOpenChange={onOpenChange}
      title={stat ? humanizeText(stat.category) : ''}
      description={stat ? description : ''}
      transactions={outlierTransactions}
      contextId="anomalies-category-outliers"
      exportFilename="category-outliers"
      metadata={
        stat && (
          <MetadataPanel
            stat={stat}
            outlierCount={outlierCount}
            outlierAmount={outlierAmount}
          />
        )
      }
    />
  )
}
